import { render } from "./NotificationButtonComponent.vue?vue&type=template&id=453e06f4&scoped=true&ts=true"
import script from "./NotificationButtonComponent.vue?vue&type=script&lang=ts"
export * from "./NotificationButtonComponent.vue?vue&type=script&lang=ts"

import "./NotificationButtonComponent.vue?vue&type=style&index=0&id=453e06f4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-453e06f4"]])

export default __exports__